const GENERIC_NETWORK_MESSAGE = "Network error - please check your connection";
const GENERIC_UNEXPECTED_MESSAGE = "Unexpected response from server";
const GENERIC_FAILURE_MESSAGE = "Something went wrong. Please try again.";

const isPlainObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const truncate = (str, max = 500) => {
  if (typeof str !== "string") return str;
  return str.length > max ? `${str.slice(0, max - 1)}…` : str;
};

export const parseApiError = (error) => {
  const result = {
    status: 0,
    error: "",
    message: GENERIC_FAILURE_MESSAGE,
    path: "",
    timestamp: null,
    raw: error,
    isNetworkError: false,
    isUnauthorized: false,
  };

  if (!error) return result;

  if (error.code === "ERR_NETWORK") {
    result.isNetworkError = true;
    result.message = GENERIC_NETWORK_MESSAGE;
    return result;
  }

  if (!error.response) {
    result.isNetworkError = true;
    result.message = error.message || GENERIC_NETWORK_MESSAGE;
    return result;
  }

  const { status, data } = error.response;
  result.status = status || 0;
  result.isUnauthorized = status === 401;

  if (isPlainObject(data)) {
    result.error = typeof data.error === "string" ? data.error : "";
    result.path = typeof data.path === "string" ? data.path : "";
    result.timestamp = typeof data.timestamp === "string" ? data.timestamp : null;
    if (typeof data.message === "string" && data.message.length > 0) {
      result.message = truncate(data.message);
    } else {
      result.message = truncate(JSON.stringify(data));
    }
    return result;
  }

  if (typeof data === "string" && data.length > 0) {
    result.message = truncate(data);
    return result;
  }

  result.message = error.message || GENERIC_UNEXPECTED_MESSAGE;
  return result;
};

export default parseApiError;
